export default __webpack_public_path__ + "static/media/6.9c02846e.jpg";